import styled from 'styled-components';

export const LeftColumn = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  max-width: 568px;
`;
